/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type WithdrawAccTypesEnum = "Bank_Acc" | "UPI" | "%future added value";
export type WithdrawMoneyFromWalletMutationVariables = {|
  amount: number,
  accType?: ?WithdrawAccTypesEnum,
|};
export type WithdrawMoneyFromWalletMutationResponse = {|
  +withdrawWallet: ?{|
    +message: ?string
  |}
|};
export type WithdrawMoneyFromWalletMutation = {|
  variables: WithdrawMoneyFromWalletMutationVariables,
  response: WithdrawMoneyFromWalletMutationResponse,
|};
*/


/*
mutation WithdrawMoneyFromWalletMutation(
  $amount: Int!
  $accType: WithdrawAccTypesEnum
) {
  withdrawWallet(amount: $amount, accType: $accType) {
    message
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amount"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accType",
        "variableName": "accType"
      },
      {
        "kind": "Variable",
        "name": "amount",
        "variableName": "amount"
      }
    ],
    "concreteType": "WalletWithdraw",
    "kind": "LinkedField",
    "name": "withdrawWallet",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WithdrawMoneyFromWalletMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WithdrawMoneyFromWalletMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "72dd437e91586d69b1ce755cbdd7f29f",
    "id": null,
    "metadata": {},
    "name": "WithdrawMoneyFromWalletMutation",
    "operationKind": "mutation",
    "text": "mutation WithdrawMoneyFromWalletMutation(\n  $amount: Int!\n  $accType: WithdrawAccTypesEnum\n) {\n  withdrawWallet(amount: $amount, accType: $accType) {\n    message\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0e84c600cbc47a1ba649ca0ef4a87b11';

module.exports = node;
